(function () {
  'use strict';

  function getLabel(blockItem) {
    var s = blockItem.querySelector('.accordion__toggle-content');
    if (s) return s.textContent.trim();
    var f = blockItem.querySelector('summary');
    if (f) return f.textContent.trim();
    return 'Description';
  }

  function getHTML(blockItem) {
    var c = blockItem.querySelector('.accordion__content');
    if (c) return c.innerHTML;
    var p = blockItem.querySelector('.prose');
    if (p) return p.innerHTML;
    return '';
  }

  function buildTabs(blocks) {
    var container = document.createElement('div');
    container.className = 'chula-tabs-container';

    var tabList = document.createElement('div');
    tabList.className = 'chula-tabs__list';
    container.appendChild(tabList);

    var contentArea = document.createElement('div');
    contentArea.className = 'chula-tabs__content';
    container.appendChild(contentArea);

    blocks.forEach(function (item, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'chula-tabs__tab';
      btn.textContent = getLabel(item);
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      tabList.appendChild(btn);

      var panel = document.createElement('div');
      panel.className = 'chula-tab-panel';
      panel.style.display = i === 0 ? 'block' : 'none';
      panel.innerHTML = getHTML(item);
      contentArea.appendChild(panel);

      btn.addEventListener('click', function () {
        tabList.querySelectorAll('.chula-tabs__tab').forEach(function (t) {
          t.setAttribute('aria-selected', 'false');
        });
        contentArea.querySelectorAll('.chula-tab-panel').forEach(function (p) {
          p.style.display = 'none';
        });
        btn.setAttribute('aria-selected', 'true');
        panel.style.display = 'block';
      });
    });

    // Find if blocks are inside an accordion-group custom element
    var accordionGroup = blocks[0].closest('accordion-group');
    var insertTarget = accordionGroup || blocks[0];
    var parent = insertTarget.parentNode;

    // Insert our container BEFORE the accordion-group (or first block)
    parent.insertBefore(container, insertTarget);

    // Now completely remove the accordion-group (or hide each block)
    if (accordionGroup) {
      accordionGroup.remove();
    } else {
      blocks.forEach(function (b) { b.remove(); });
    }
  }

  function initTabs() {
    var list = document.querySelector('.product-info__block-list');
    if (!list) return;

    var desc = list.querySelector('[data-block-type="description"]');
    var accordions = Array.from(list.querySelectorAll('[data-block-type="accordion"]'));

    var blocks = [];
    if (desc) blocks.push(desc);
    blocks = blocks.concat(accordions);

    if (blocks.length >= 2) buildTabs(blocks);
  }

  // Build as soon as the blocks exist, which is already true when this runs.
  //
  // This used to hand everything to DOMContentLoaded whenever readyState was
  // 'loading' — which it always is, because the tag is parser-blocking. But
  // the tag sits AFTER .product-info__block-list in the document, so the
  // description and the two accordions are parsed and paintable by the time
  // this line is reached, and there are ~319KB of HTML still to come after
  // it. Measured on /products/tokyo-chochin-dress 2026-09-27: the script
  // finished at 1508ms and the tabs were not assembled until 1888ms, leaving
  // a 380ms window in which the raw stack — full description, then a "Care"
  // row, then a "Delivery & Returns" row — was on screen before being
  // replaced by the tab strip. That swap is what reads as the page loading
  // broken.
  //
  // Waiting for DOMContentLoaded is still the correct fallback for the case
  // this cannot see: a tag moved above the markup, or blocks rendered later.
  function boot() {
    var list = document.querySelector('.product-info__block-list');
    if (list && list.querySelector('[data-block-type]')) {
      initTabs();
      return;
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTabs);
    } else {
      initTabs();
    }
  }

  boot();
})();